/**
 * Canonical unread-notification-count query.
 * Single source of truth for the header bell, sidebar nav badges, dashboard
 * indicators, and the App Badge — every consumer must share this exact query
 * key so a mark-as-read anywhere invalidates the count everywhere.
 */
import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

export const UNREAD_COUNT_QUERY_KEY = ['notifications', 'unread-count'] as const;

export function useUnreadNotificationCount() {
  return useQuery({
    queryKey: UNREAD_COUNT_QUERY_KEY,
    queryFn: async () => {
      const response = await api.get('/notifications/unread-count');
      return response.data?.data?.count ?? 0;
    },
    refetchInterval: 30_000,
  });
}
